import { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import NotificationService from 'services/NotificationService';
import { translate } from 'services/i18nService';


const EMAIL_NOTIFICATION_TIMEOUT = 1000;

@withRouter
export default class EmailVerifiedNotification extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { location, history } = this.props;
    const params = new URLSearchParams(location.search);
    const emailValid = params.get('emailValid');

    if (emailValid) {
      setTimeout(this.triggerEmailNotification, EMAIL_NOTIFICATION_TIMEOUT);

      params.delete('emailValid');
      history.replace({ search: params.toString() });
    }
  }

  triggerEmailNotification = () => {
    NotificationService.create({
      type: NotificationService.type.TOAST,
      subtype: NotificationService.subtype.SUCCESS,
      text: translate('account.emails.notifications.emailValid'),
    });
  };

  render() {
    return null;
  }
}
